import type React from 'react';

import { company } from '~/company/Company';
import { HeaderFavs } from '~/components/MobileHeaderCD/components/HeaderFavs';

import { CartButton } from './components/CartButton';
import { ProfileButton } from './components/ProfileButton';
import styles from './UserActions.module.scss';

export const UserActions: React.FC = () => {
  return (
    <div className={styles.actionButtons} data-company={company.name}>
      <HeaderFavs
        enableLabel={false}
        className={company.match({
          mcosmetic:
            'text-graphic-regular-white! transition-colors duration-300 group-data-[scrolled=true]:text-icon-primary!',
          default: styles.favs,
        })}
        overlayClassName={styles.overlay}
        dropdownClassName={company.match({
          mcosmetic:
            'max-w-[480px] right-[128px] left-auto! transform-[translate(0)]! bg-bg-base!',
          default: styles.dropdownFavs,
        })}
      />
      <ProfileButton />
      <CartButton />
    </div>
  );
};
